"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.circle_user_checkmark = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var circle_user_checkmark = function circle_user_checkmark(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'circle_user_checkmark', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M8.5 8.5C8.5 9.32843 9.17157 10 10 10C10.8284 10 11.5 9.32843 11.5 8.5C11.5 7.67157 10.8284 7 10 7C9.17157 7 8.5 7.67157 8.5 8.5Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M7 11.5V12C7 12.5523 7 13 8 13H11.126C11.3723 12.0431 11.9638 11.2247 12.7599 10.6856C12.4926 10.273 12.0282 10 11.5 10H10H8.5C7.67157 10 7 10.6716 7 11.5Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M10 4.75C7.10051 4.75 4.75 7.10051 4.75 10C4.75 12.8995 7.10051 15.25 10 15.25C10.3984 15.25 10.7864 15.2056 11.1594 15.1216C11.3062 15.6253 11.5495 16.088 11.8679 16.4882C11.2747 16.6587 10.648 16.75 10 16.75C6.27208 16.75 3.25 13.7279 3.25 10C3.25 6.27208 6.27208 3.25 10 3.25C13.7279 3.25 16.75 6.27208 16.75 10C16.75 10.1331 16.7461 10.2653 16.7385 10.3966C16.2837 10.1767 15.7808 10.0404 15.25 10.0077L15.25 10C15.25 7.10051 12.8995 4.75 10 4.75ZM15 17C14.1667 17 13.4127 16.6602 12.8691 16.1117C12.5146 15.754 12.2496 15.3076 12.1103 14.8087C12.0384 14.5514 12 14.2802 12 14C12 13.6475 12.0608 13.3092 12.1725 12.9951C12.3423 12.5173 12.6297 12.0953 13 11.7639C13.03 11.737 13.0606 11.7107 13.0917 11.6851C13.6103 11.2571 14.2751 11 15 11C15.0517 11 15.1031 11.0013 15.1541 11.0039C15.6808 11.0305 16.1717 11.193 16.5923 11.457C17.4379 11.9876 18 12.9281 18 14C18 15.6569 16.6569 17 15 17ZM13.8536 13.6464L13.1464 14.3536L14.1313 15.3384L14.5 15.7071L16.8536 13.3536L16.1919 12.6919L16.1464 12.6464L14.5 14.2929L13.8536 13.6464Z',
    fill: '#4B5563'
  }));
};

exports.circle_user_checkmark = circle_user_checkmark;